import React, { useState } from "react";
import SuperAdminSidebar from "./Components/SuperAdminSidebar";
import hamburger_icon from "../../assets/icons/hamburger_icon.png";
import SuperAdminSearchBar from "./Components/SuperAdminSearchBar";
import search_icon from "../../assets/icons/search_icon.png";
import threeHorizontalDots_icon from "../../assets/icons/threeHorizontalDots_icon.png";
import users_icon_02 from "../../assets/icons/users_icon_02.png";
import comments_icon from "../../assets/icons/comments_icon.png";
import files_icon from "../../assets/icons/files_icon.png";
import superAdminSale_Image from "../../assets/images/superAdminSale_Image.png";
import superAdminTaskAllocation_image from "../../assets/images/superAdminTaskAllocation_image.png";
import superAdminClientStats_image from "../../assets/images/superAdminClientStats_image.png";
import CreateNewTicket from "../../components/modals/CreateNewTicket";
import SocialMediaPostModal from "../../components/modals/SocialMediaPostModal";

const SupportTickets = () => {
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);
  const [isAction, setAction] = useState(false);
  const [siteName, setSiteName] = useState("Shoppers Stop");
  const [newTicket, setNewTicket] = useState(false);
  const [socialMediaPost, setSocialMediaPost] = useState(false);

  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };

  const handleSiteName = (name) => {
    setSiteName(name);
    setAction(false);
  };

  return (
    <div>
      <div className="flex items-center justify-center w-full">
        <div
          className="items-center justify-center hidden hamburger"
          onClick={toggleNavbar}
        >
          <img
            src={hamburger_icon}
            alt="hamburger"
            className="object-contain"
          />
        </div>
        <div className="flex items-center justify-center w-full">
          <SuperAdminSearchBar
            categoryName="Support Tickets"
            route="/super-admin/payment-details"
          />
        </div>
        <div className="absolute top-0 w-[70%] z-20 bg-white rounded-lg mt-16">
          {isNavbarVisible && <SuperAdminSidebar />}
        </div>
      </div>

      <div className="relative flex items-center ml-4 mt-6">
        <div
          className="flex items-center cursor-pointer"
          onClick={() => setAction(!isAction)}
        >
          <div className="text-[18px] font-bold">{siteName}</div>
          <span className="text-md ml-2 mb-3 font-semibold">&#x2304;</span>
        </div>

        {isAction ? (
          <div className="absolute mt-32">
            <div className="flex flex-col justify-start items-center w-[6rem] bg-white shadow-lg border border-[#F7F1E1] rounded-lg cursor-pointer mr-2">
              <div
                className="text-[12px] py-1"
                onClick={() => handleSiteName("Westside")}
              >
                Westside
              </div>
              <div
                className="text-[12px] py-1"
                onClick={() => handleSiteName("Home Center")}
              >
                Home Center
              </div>
              <div
                className="text-[12px] py-1"
                onClick={() => handleSiteName("Uniliver")}
              >
                Uniliver
              </div>
              <div
                className="text-[12px] py-1"
                onClick={() => handleSiteName("Indian Oil")}
              >
                Indian Oil
              </div>
              <div
                className="text-[12px] py-1"
                onClick={() => handleSiteName("KFC")}
              >
                KFC
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>

      <div className="ml-4 mt-4 flex justify-between w-[95%] ">
        <div className="flex bg-[#F5F5F5] px-4 rounded-xl w-[30%]">
          <img
            src={search_icon}
            className="object-cover w-10 p-2"
            alt="search"
          />
          <input
            placeholder="Search for anything..."
            className="bg-[#F5F5F5] p-1 w-full text-[14px]"
          />
        </div>
        <div onClick={() => setNewTicket(true)}>
          <p className="bg-[#2F80ED] p-2 px-4 text-[14px] text-white rounded-lg cursor-pointer">
            Create Ticket
          </p>
        </div>
      </div>

      <div className="ml-4 my-4 flex config-col justify-between w-[95%] mb-10">
        {/* To Do */}
        <div className="w-[30%] card--one bg-[#F5F5F5] p-4 rounded-lg">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <p className="h-1 w-1 bg-[#76A5EA] rounded-full"></p>
              <p className="text-[16px] font-bold ml-2">To Do</p>
              <p className="bg-[#E0E0E0] text-[12px] w-4 h-4 flex justify-center ml-2 rounded-full font-bold">
                4
              </p>
            </div>

            <p className="bg-[#2f81ed45] text-[#2F80ED] w-5 h-5 rounded-md flex justify-center items-center cursor-pointer">
              +
            </p>
          </div>

          <div className="mt-4 h-1 w-full bg-[#2F80ED]"></div>
          {/* 1 */}
          <div className="mt-4 rounded-lg ">
            <div className="flex flex-col justify-between mt-2 config-col">
              <div className="bg-white p-2 px-4 rounded-lg super-admin-card-01">
                <div className="flex justify-between">
                  <p className="text-[#D58D49] bg-[#dfa87446] text-[12px] py-1 px-2 rounded-lg font-bold">
                    Low
                  </p>
                  <img
                    src={threeHorizontalDots_icon}
                    alt="three dots"
                    className="object-contain w-4"
                  />
                </div>
                <p className="text-[18px] font-bold mt-2">Brainstorming</p>
                <p className="text-[12px] text-[#787486] mt-2">
                  Brainstorming brings team members' diverse experience into
                  play.{" "}
                </p>

                <div className="flex justify-between mt-6">
                  <img
                    src={users_icon_02}
                    alt="users"
                    className="w-16 object-contain"
                  />
                  <div className="flex items-center text-[12px] text-[#787486]">
                    <img
                      src={comments_icon}
                      alt="comments"
                      className="object-contain w-4 mr-1"
                    />
                    <p>12 comments</p>
                  </div>
                  <div className="flex items-center text-[12px] text-[#787486]">
                    <img
                      src={files_icon}
                      alt="files"
                      className="object-contain w-4 mr-1"
                    />
                    <p>0 files</p>
                  </div>
                </div>
              </div>
              {/* 2 */}
              <div className="bg-white mt-4 p-2 px-4 rounded-lg super-admin-card-01">
                <div className="flex justify-between ">
                  <p className="text-[#D8727D] bg-[#d8727c24] text-[12px] py-1 px-2 rounded-lg font-bold">
                    High
                  </p>
                  <img
                    src={threeHorizontalDots_icon}
                    alt="three dots"
                    className="object-contain w-4"
                  />
                </div>
                <p className="text-[18px] font-bold mt-2">Research</p>
                <p className="text-[12px] text-[#787486] mt-2">
                  User research helps you to create an optimal product for
                  users.
                </p>

                <div className="flex justify-between mt-6">
                  <img
                    src={users_icon_02}
                    alt="users"
                    className="w-16 object-contain"
                  />
                  <div className="flex items-center text-[12px] text-[#787486]">
                    <img
                      src={comments_icon}
                      alt="comments"
                      className="object-contain w-4 mr-1"
                    />
                    <p>12 comments</p>
                  </div>
                  <div className="flex items-center text-[12px] text-[#787486]">
                    <img
                      src={files_icon}
                      alt="files"
                      className="object-contain w-4 mr-1"
                    />
                    <p>0 files</p>
                  </div>
                </div>
              </div>
              {/* 3 */}
              <div className="bg-white mt-4 p-2 px-4 rounded-lg super-admin-card-01">
                <div className="flex justify-between">
                  <p className="text-[#D8727D] bg-[#d8727c24] text-[12px] py-1 px-2 rounded-lg font-bold">
                    High
                  </p>
                  <img
                    src={threeHorizontalDots_icon}
                    alt="three dots"
                    className="object-contain w-4"
                  />
                </div>
                <p className="text-[18px] font-bold mt-2">Team Strategy</p>
                <p className="text-[12px] text-[#787486] mt-2">
                  Team strategy encourages teamwork, breaking down silos for
                  successful execution.
                </p>

                <div className="flex justify-between mt-6">
                  <img
                    src={users_icon_02}
                    alt="users"
                    className="w-16 object-contain"
                  />
                  <div className="flex items-center text-[12px] text-[#787486]">
                    <img
                      src={comments_icon}
                      alt="comments"
                      className="object-contain w-4 mr-1"
                    />
                    <p>12 comments</p>
                  </div>
                  <div className="flex items-center text-[12px] text-[#787486]">
                    <img
                      src={files_icon}
                      alt="files"
                      className="object-contain w-4 mr-1"
                    />
                    <p>0 files</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* On Progress */}
        <div className="w-[30%] card--one bg-[#F5F5F5] p-4 rounded-lg">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <p className="h-1 w-1 bg-[#FFA500] rounded-full"></p>
              <p className="text-[16px] font-bold ml-2">On Progress</p>
              <p className="bg-[#E0E0E0] text-[12px] w-4 h-4 flex justify-center ml-2 rounded-full font-bold">
                3
              </p>
            </div>

            <p className="bg-[#2f81ed45] text-[#2F80ED] w-5 h-5 rounded-md flex justify-center items-center cursor-pointer">
              +
            </p>
          </div>

          <div className="mt-4 h-1 w-full bg-[#FFA500]"></div>
          {/* 1 */}
          <div
            className="mt-4 rounded-lg cursor-pointer"
            onClick={() => setSocialMediaPost(true)}
          >
            <div className="flex flex-col justify-between mt-2 config-col">
              <div className="bg-white p-2 px-4 rounded-lg super-admin-card-01">
                <div className="flex justify-between">
                  <p className="text-[#D58D49] bg-[#dfa87446] text-[12px] py-1 px-2 rounded-lg font-bold">
                    Low
                  </p>
                  <img
                    src={threeHorizontalDots_icon}
                    alt="three dots"
                    className="object-contain w-4"
                  />
                </div>
                <p className="text-[18px] font-bold my-2">Social Media Posts</p>
                <img
                  src={superAdminSale_Image}
                  alt="sale"
                  className="object-contain rounded-lg"
                />

                <div className="flex justify-between mt-6">
                  <img
                    src={users_icon_02}
                    alt="users"
                    className="w-16 object-contain"
                  />
                  <div className="flex items-center text-[12px] text-[#787486]">
                    <img
                      src={comments_icon}
                      alt="comments"
                      className="object-contain w-4 mr-1"
                    />
                    <p>12 comments</p>
                  </div>
                  <div className="flex items-center text-[12px] text-[#787486]">
                    <img
                      src={files_icon}
                      alt="files"
                      className="object-contain w-4 mr-1"
                    />
                    <p>0 files</p>
                  </div>
                </div>
              </div>
              {/* 2 */}
              <div className="bg-white mt-4 p-2 px-4 rounded-lg super-admin-card-01">
                <div className="flex justify-between ">
                  <p className="text-[#D58D49] bg-[#dfa87446] text-[12px] py-1 px-2 rounded-lg font-bold">
                    Low
                  </p>
                  <img
                    src={threeHorizontalDots_icon}
                    alt="three dots"
                    className="object-contain w-4"
                  />
                </div>
                <p className="text-[18px] font-bold my-2">Task Allocation</p>
                <img
                  src={superAdminTaskAllocation_image}
                  alt="task allocation"
                />

                <div className="flex justify-between mt-6">
                  <img
                    src={users_icon_02}
                    alt="users"
                    className="w-16 object-contain"
                  />
                  <div className="flex items-center text-[12px] text-[#787486]">
                    <img
                      src={comments_icon}
                      alt="comments"
                      className="object-contain w-4 mr-1"
                    />
                    <p>12 comments</p>
                  </div>
                  <div className="flex items-center text-[12px] text-[#787486]">
                    <img
                      src={files_icon}
                      alt="files"
                      className="object-contain w-4 mr-1"
                    />
                    <p>0 files</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Done */}
        <div className="w-[30%] card--one bg-[#F5F5F5] p-4 rounded-lg">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <p className="h-1 w-1 bg-[#76A5EA] rounded-full"></p>
              <p className="text-[16px] font-bold ml-2">Done</p>
              <p className="bg-[#E0E0E0] text-[12px] w-4 h-4 flex justify-center ml-2 rounded-full font-bold">
                2
              </p>
            </div>

            <p className="bg-[#2f81ed45] text-[#2F80ED] w-5 h-5 rounded-md flex justify-center items-center cursor-pointer">
              +
            </p>
          </div>

          <div className="mt-4 h-1 w-full bg-[#2F80ED]"></div>
          {/* 1 */}
          <div className="mt-4 rounded-lg ">
            <div className="flex flex-col justify-between mt-2 config-col">
              <div className="bg-white p-2 px-4 rounded-lg super-admin-card-01">
                <div className="flex justify-between">
                  <p className="text-[#68B266] bg-[#69b2662e] text-[12px] py-1 px-2 rounded-lg font-bold">
                    Completed
                  </p>
                  <img
                    src={threeHorizontalDots_icon}
                    alt="three dots"
                    className="object-contain w-4"
                  />
                </div>
                <p className="text-[18px] font-bold my-2">Client Stats</p>
                <img
                  src={superAdminClientStats_image}
                  alt="client stats"
                  className="object-contain rounded-lg"
                />

                <div className="flex justify-between mt-6">
                  <img
                    src={users_icon_02}
                    alt="users"
                    className="w-16 object-contain"
                  />
                  <div className="flex items-center text-[12px] text-[#787486]">
                    <img
                      src={comments_icon}
                      alt="comments"
                      className="object-contain w-4 mr-1"
                    />
                    <p>12 comments</p>
                  </div>
                  <div className="flex items-center text-[12px] text-[#787486]">
                    <img
                      src={files_icon}
                      alt="files"
                      className="object-contain w-4 mr-1"
                    />
                    <p>0 files</p>
                  </div>
                </div>
              </div>
              {/* 2 */}
              <div className="bg-white mt-4 p-2 px-4 rounded-lg super-admin-card-01">
                <div className="flex justify-between ">
                  <p className="text-[#68B266] bg-[#69b2662e] text-[12px] py-1 px-2 rounded-lg font-bold">
                    Completed
                  </p>
                  <img
                    src={threeHorizontalDots_icon}
                    alt="three dots"
                    className="object-contain w-4"
                  />
                </div>
                <p className="text-[18px] font-bold mt-2">Summer Campaign</p>
                <p className="text-[12px] text-[#787486] mt-2">
                  It just needs to adapt the UI from what you did before
                </p>

                <div className="flex justify-between mt-6">
                  <img
                    src={users_icon_02}
                    alt="users"
                    className="w-16 object-contain"
                  />
                  <div className="flex items-center text-[12px] text-[#787486]">
                    <img
                      src={comments_icon}
                      alt="comments"
                      className="object-contain w-4 mr-1"
                    />
                    <p>12 comments</p>
                  </div>
                  <div className="flex items-center text-[12px] text-[#787486]">
                    <img
                      src={files_icon}
                      alt="files"
                      className="object-contain w-4 mr-1"
                    />
                    <p>0 files</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {newTicket ? <CreateNewTicket setNewTicket={setNewTicket} /> : null}
      {socialMediaPost ? (
        <SocialMediaPostModal setSocialMediaPost={setSocialMediaPost} />
      ) : null}
    </div>
  );
};

export default SupportTickets;
